
import {
    ADD_TEAM_TABLE_REQUEST,
    ADD_TEAM_TABLE_SUCCESS,
    ADD_TEAM_TABLE_FAIL,
    DELETE_TEAM_REQUEST,
    DELETE_TEAM_SUCCESS,
    DELETE_TEAM_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const TeamTableAction = (id, department, candidateId, search, pageNumber, pathname) => {
  console.log('team000-- ', id, candidateId)
    return function (dispatch) {
      dispatch({
        type: ADD_TEAM_TABLE_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_candidate_by_vendorId?vendorId=${id}&pageNumber=${pathname ? pageNumber : -1}&pageSize=${pathname ? 10 : -1}&department=${department || ''}&search=${search || ''}&candidateId=${candidateId??""}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: ADD_TEAM_TABLE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  const loadAllDetailsPre = (data) => {
    return {
      type: ADD_TEAM_TABLE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };

  export const DeleteTeamAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: DELETE_TEAM_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/soft_delete_teamMember?candidateId=${id}`,
        method: "DELETE",
        // data: id,
        headers: {
          "content-type": "application/json",
        },
      };
  
      axios(OPTION)
        .then((res) => {
          dispatch(deleteTeamsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: DELETE_TEAM_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const deleteTeamsPre = (data) => {
    toast.success("Deleted Successfully!");
    setTimeout(()=>{
        window.location.href = "/team-list";
     },2000)
    return {
      type: DELETE_TEAM_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };

 